export default __webpack_public_path__ + "static/media/ModernTechJobs.29c48202f8ed659d0f2d12da2a0e0768.webp";